<template>
  <ContainerArea class="ArchiveDashboard">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner :title="archiveTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <MonthSelector
        :year="currentYear"
        :start-date="firstPublication"
        :period="periodCode"
      />
    </LayoutGutters>
    <LayoutGutters>
      <v-div v-if="results.length === 0" title foreground-muted
        >No Articles this month</v-div
      >
      <ArchiveResult
        v-for="result in results"
        v-else
        :key="result.item.id"
        :article="result.item"
        :highlight="result.highlight"
      />
    </LayoutGutters>
    <LayoutGutters>
      <v-div headline mb-3 foreground-primary>Complete Archive</v-div>
      <MonthSelector
        v-for="year in years"
        :key="year"
        :year="year"
        :start-date="firstPublication"
        :period="periodCode"
      />
    </LayoutGutters>
  </ContainerArea>
</template>

<script>
import { mapState } from "vuex";
import { format, parseISO, getYear } from "date-fns";
import getPageTitle from "~/plugins/utilities/getPageTitle.js";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

import ContainerArea from "~/components/layout/ContainerArea";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";

import MainBanner from "~/components/banner/MainBanner.vue";
import ArchiveResult from "~/components/matches/ArchiveResult.vue";

import MonthSelector from "~/components/navigation/MonthSelector.vue";

import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "ArchiveDashboard",
  components: {
    ContainerArea,
    LayoutGutters,
    LayoutFill,
    MainBanner,
    MonthSelector,
    ArchiveResult,
  },
  scrollToTop: true,
  async fetch(context) {
    const { store, query, req, res, error } = context;
    const params = { ...query };

    params.period = params.period || format(new Date(), "yyyy-MM");

    try {
      await store.dispatch("loadArchiveDashboard", { params, req, res });
    } catch (err) {
      error(err);
    }
  },
  head() {
    const { siteName } = this;

    const title = getPageTitle(siteName);
    const pageTitle = "Archive" + " | " + title;
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    return {
      title: pageTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: `Review the archive to discover early research outputs such as conference papers and presentations on ${siteName}, ${cupTechText} Cambridge University Press`,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.theme,
      layout: (state) => state.theme.layout,
      totalCount: (state) => state.archiveResult.totalCount,
      results: (state) => state.archiveResult.results,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
      period: (state) => state.archiveRequest.period,
    }),
    displayIsDesktop,
    displayIsMobile,
    displayIsTablet,
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    archiveTitle() {
      return "Archive " + this.periodName;
    },
    periodCode() {
      return this.period;
    },
    periodName() {
      const periodDate = new Date(this.periodCode);

      return format(periodDate, "MMMM yyyy");
    },
    firstPublication() {
      return this.theme.firstPublication || new Date();
    },
    years() {
      const startYear = getYear(parseISO(this.firstPublication));
      const endYear = getYear(new Date());

      const years = [];

      for (let i = startYear; i <= endYear; i++) {
        years.push(i);
      }

      return years.reverse();
    },
    currentYear() {
      return getYear(new Date());
    },
  },
  watchQuery: ["period"],
};
</script>
